import React, { useEffect, useState } from 'react'
import {Link} from 'react-router-dom'
import { ShoppingCart, User, Wrench } from 'lucide-react'
import styled from 'styled-components'
import { useAuth } from '../../authContext'

export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  border-bottom: 1px solid #e2e8f0;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
`

export const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  height: 72px;
  align-items: center;
  padding: 0 1rem;
`

export const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: bold;
  margin-right: 2rem;
  color: #0f172a;
  text-decoration: none;
`

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  overflow-x: auto;
  white-space: nowrap;
  @media(max-width: 640px) { gap: 0.8rem; }
`

export const NavLink = styled(Link)`
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
  opacity: ${props => props.active ? 1 : 0.6};
  transition: opacity 0.2s;
  text-decoration: none;
  
  &:hover {
    opacity: 0.8;
  }
`

export const AdminNavButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: white;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  text-decoration: none;
  box-shadow: 0 2px 5px rgba(239, 68, 68, 0.3);
  transition: all 0.2s;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(239, 68, 68, 0.4);
  }
`

const navigation = [
  { name: "Programming", href: "/course-library/1" },
  { name: "Graphics", href: "/course-library/2" },
  { name: "Database", href: "/course-library/3" },
  { name: "DevOps", href: "/course-library/4" },
  { name: "Infra", href: "/course-library/5" },
]

export function Header() {
  const { isLoggedIn } = useAuth();
  const [canUseMaintenance, setCanUseMaintenance] = useState(false);
  useEffect(() => {
    setCanUseMaintenance(false);
    if (!isLoggedIn) return undefined;
    const controller = new AbortController();
    fetch('/api/maintenance/whoami', { credentials: 'include', cache: 'no-store', signal: controller.signal })
      .then(response => response.ok ? response.json() : null)
      .then(data => { if (!controller.signal.aborted) setCanUseMaintenance(data?.capabilities?.canReport === true); })
      .catch(() => {});
    return () => controller.abort();
  }, [isLoggedIn]);

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo to="/">AntsNest</Logo>
        <Nav>
          {navigation.map((item) => (
            <NavLink key={item.href} to={item.href}>
              {item.name}
            </NavLink>
          ))}
          {canUseMaintenance && (
            <AdminNavButton to="/Maintenance">
              <Wrench size={16} /> 내 유지보수 큐
            </AdminNavButton>
          )}
        </Nav>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <NavLink key="Cart" to="/Cart">
            <ShoppingCart size={20} />
          </NavLink>
          <NavLink key={isLoggedIn ? "MyPage" : "Login"} to={isLoggedIn ? "/MyPage" : "/Login"}>
            <User size={20} />
          </NavLink>
        </div>
      </HeaderContent>
    </HeaderContainer>
  )
}
